import React, { createContext, useContext, useMemo, useState } from 'react';
import { DONORS_SEED, GRANTS_SEED, FYS, PROGRAMS, PROGRAM_LIST, REGIONS, TODAY } from '@/data/seed';

const DashboardContext = createContext(null);

export const useDashboard = () => {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error('useDashboard must be used within DashboardProvider');
  return ctx;
};

const uid = (p = 'x') => `${p}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;

export const DashboardProvider = ({ children }) => {
  const [donors, setDonors] = useState(DONORS_SEED);
  const [grants, setGrants] = useState(GRANTS_SEED);
  const [fy, setFy] = useState('FY 25-26');
  const [collapsed, setCollapsed] = useState(false);

  const addDonor    = (d) => setDonors((prev) => [{ ...d, id: uid('D') }, ...prev]);
  const updateDonor = (id, patch) => setDonors((prev) => prev.map((d) => d.id === id ? { ...d, ...patch } : d));
  const removeDonor = (id) => setDonors((prev) => prev.filter((d) => d.id !== id));

  const addGrant    = (g) => setGrants((prev) => [{ ...g, id: uid('G') }, ...prev]);
  const updateGrant = (id, patch) => setGrants((prev) => prev.map((g) => g.id === id ? { ...g, ...patch } : g));
  const removeGrant = (id) => setGrants((prev) => prev.filter((g) => g.id !== id));

  // Derived totals across all grants (portfolio view)
  const totals = useMemo(() => {
    const sanct = grants.reduce((s, g) => s + g.sanct, 0);
    const recd  = grants.reduce((s, g) => s + g.recd, 0);
    const util  = grants.reduce((s, g) => s + g.util, 0);
    const benef = grants.reduce((s, g) => s + g.benef, 0);
    return { sanct, recd, util, benef };
  }, [grants]);

  return (
    <DashboardContext.Provider value={{
      donors, grants, fy, setFy, collapsed, setCollapsed,
      PROGRAMS, PROGRAM_LIST, FYS, REGIONS, TODAY,
      addDonor, updateDonor, removeDonor,
      addGrant, updateGrant, removeGrant,
      totals,
    }}>
      {children}
    </DashboardContext.Provider>
  );
};
